

const forms = {
  // Forms
  forms: {
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm Password",
    firstName: "First Name",
    lastName: "Last Name",
    submit: "Submit",
    reset: "Reset"
  },

  // Form
  form: {
    title: "Ticket Configuration",
    username: "Username or Email",
    usernamePlaceholder: "Enter your username or email",
    password: "Password",
    passwordPlaceholder: "Enter your password",
    name: "Name",
    namePlaceholder: "Enter your full name",
    emailPlaceholder: "Enter your email address",
    forgotPassword: "Forgot password?",
    createAccount: "Create account",
    alreadyHaveAccount: "Already have an account?",
    sendLink: "Send reset link",
    backToLogin: "Back to login",
    generalTicket: "General Ticket",
    leagueSelection: "League Selection",
    matchOddsLimits: "Match Odds Limits",
    predictions: "Predictions",
    confidenceScore: "Confidence Score",
    // Additional form translations
    games: "Number of Games",
    game: "Game",
    games_plural: "Games",
    date: "Date",
    today: "Today",
    range: "Date Range",
    start: "Start Date",
    end: "End Date",
    action: "Action",
    include: "Include",
    exclude: "Exclude",
    selectInclude: "Select leagues to include",
    selectExclude: "Select leagues to exclude"
  },

  // Missing translations that might be causing the key display issue
  ticketForm: {
    title: "Ticket Configuration",
    generalSettings: "General Settings",
    leagueSettings: "League Settings", 
    oddsSettings: "Odds Settings",
    predictionSettings: "Prediction Settings",
    minOdds: "Minimum Odds",
    maxOdds: "Maximum Odds",
    leagues: "Leagues",
    selectLeagues: "Select Leagues",
    numberOfMatches: "Number of Matches",
    stake: "Stake Amount",
    confidence: "Confidence Level",
    generateTicket: "Generate Ticket",
    loading: "Loading...",
    error: "Error occurred",
    success: "Success"
  }
};

export default forms;

